// extracted by mini-css-extract-plugin
module.exports = {"InputText":"styles_InputText__Uvk6w","icon":"styles_icon__heCUG"};